<template>
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <h4 class="p-2">Grupos Académicos</h4>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="4">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" @input="getClear('inst')">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="instituciones.length">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" :value="0">
                                        No hay datos
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="4">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter :loading="loadingCiclo" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" @input="getClear('ciclo')">
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                                <template v-if="ciclosEscolares.length">
                                    <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" :value="0">
                                        No hay datos
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="4">
                        <form autocomplete="off">
                            <label for="agrupar" class="labelInput">
                                Agrupar por
                            </label>
                            <div style="position: relative">
                                <vs-select 
                                    filter
                                    class="pt-0"
                                    id="agrupar"
                                    placeholder="Agrupar por"
                                    v-model="agrupar">
                                    <template #message-danger v-if="errorFields.includes('agrupar')">
                                        Requerido
                                    </template>
                                    <vs-option label="Código de sesión" value="codigo_sesion">
                                        Código de sesión
                                    </vs-option>
                                    <vs-option label="Docente" value="docente">
                                        Docente
                                    </vs-option>
                                    <vs-option label="Alumno" value="alumno">
                                        Alumno
                                    </vs-option>
                                    <vs-option label="Programa" value="programa">
                                        Programa
                                    </vs-option>
                                </vs-select>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="4">
                        <form autocomplete="off">
                            <label for="grupo" class="labelInput">
                                Grupo Académico
                            </label>
                            <div style="position: relative">
                                <vs-select 
                                    :disabled="docente != '' || grupoAdmin != '' || !grupos[0]"
                                    :loading="loadingGrupo"
                                    filter
                                    class="pt-0"
                                    id="grupo"
                                    placeholder="Seleccionar grupo"
                                    :key="gruposId"
                                    v-model="grupo">
                                    <template #message-danger v-if="errorFields.includes('grupo')">
                                        Requerido
                                    </template>
                                    <template v-if="grupos.length">
                                        <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" :value="0">
                                            No hay datos
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="grupo !== ''" @click="grupo = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="4">
                        <form autocomplete="off">
                            <label for="grupo" class="labelInput">
                                Grupo Administrativo
                            </label>
                            <div style="position: relative">
                                <vs-select 
                                    :disabled="docente != '' || grupo != '' || !gruposAdmin[0]"
                                    :loading="loadingGrupo"
                                    filter
                                    class="pt-0"
                                    id="grupo"
                                    placeholder="Seleccionar grupo administrativo"
                                    :key="gruposAdminId"
                                    v-model="grupoAdmin">
                                    <template #message-danger v-if="errorFields.includes('grupoAdmin')">
                                        Requerido
                                    </template>
                                    <template v-if="gruposAdmin.length">
                                        <vs-option v-for="option in gruposAdmin" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" :value="0">
                                            No hay datos
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="grupoAdmin !== ''" @click="grupoAdmin = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="4">
                        <form autocomplete="off">
                            <label for="grupo" class="labelInput">
                                Docente
                            </label>
                            <div style="position: relative">
                                <vs-select 
                                    :disabled="grupo != '' || grupoAdmin != '' || docentes[0]"
                                    :loading="loadingDocente"
                                    filter
                                    class="pt-0"
                                    id="docente"
                                    placeholder="Seleccionar docente"
                                    :key="docentesId"
                                    v-model="docente">
                                    <template #message-danger v-if="errorFields.includes('docente')">
                                        Requerido
                                    </template>
                                    <template v-if="docentes.length">
                                        <vs-option v-for="option in docentes" :key="option.id"  :label="option.text" :value="option.id">
                                            {{option.text}}
                                        </vs-option>
                                    </template>
                                    <template v-else>
                                        <vs-option label="No hay datos" :value="0">
                                            No hay datos
                                        </vs-option>
                                    </template>
                                </vs-select>
                            </div>
                            <div v-if="docente !== ''" @click="docente = ''" class="tache">
                                <i class="far fa-times-circle"></i>
                            </div>
                        </form>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col sm="12" lg="12" style="margin-top: 23px; display: flex">
                        <vs-button
                            class="ml-auto"
                            @click="getGruposAcademicos()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-alert v-if="mensaje" class="mt-2">
                    <template #title>
                        No se encontro información.
                    </template>
                </vs-alert>
                <grupos-academicos :componentKey="componentKey" :users="users" :agrupar="agruparInfo" @refreshTable="getGruposAcademicos"></grupos-academicos>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import reportes from '../../../../api/requests/reportes.js'
import GruposAcademicos from './tabla-grupos-academicos.vue'
export default {
    data(){
        return{
            institucion:'',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            grupo: '',
            grupos: [],
            gruposId: (new Date()).getTime(),
            docente: '',
            docentes: [],
            docentesId: (new Date()).getTime(),
            grupoAdmin: '',
            gruposAdmin: [],
            gruposAdminId: (new Date()).getTime(),
            errorFields: [],
            loadingInstituto: false,
            loadingCiclo: false,
            loadingGrupo: false,
            loadingDocente: false,
            loadingGrupoAdmin: false,
            users: [],
            agrupar: '',
            agruparInfo: '',
            mensaje: false,
            componentKey: 0,
        }
    },
    components:{
        GruposAcademicos
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        getClear(tipo){
            if(tipo == 'inst'){
                this.cicloEscolar = ''
                this.docente = ''
                this.grupo = '',
                this.agrupar = ''
            }else if(tipo == 'ciclo'){
                this.docente = ''
                this.grupo = '',
                this.agrupar = ''
            }
        },
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
                this.loadingInstituto = false
            }
            catch{

            }
        },
        async getCicloEscolar() {
            if(this.institucion){
                this.loadingCiclo = true
                const { data: response } = await reportes.getCiclosEscolares(this.institucion)
                this.ciclosEscolares = response
                this.cicloId = (new Date()).getTime()
                this.loadingCiclo = false
            }
        },
        async getGrupo() {
            if(this.cicloEscolar){
                try {
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar
                    }
                    this.loadingGrupo = true
                    const { data: response } = await reportes.getInfoGrupoAcademico(params, this.institucion)
                    this.grupos = this.getEliminarNameKey(response)
                    this.gruposId = (new Date()).getTime()
                    this.loadingGrupo = false
                }
                catch{

                }
            }
        },
        async getGrupoAdministrativo() {
            if(this.cicloEscolar){
                try {
                    const params = {
                        ciclo_escolar_id: this.cicloEscolar
                    }
                    this.loadingGrupo = true
                    const { data: response } = await reportes.getGrupo(this.institucion, params )
                    this.gruposAdmin = this.getEliminarNameKey(response)
                    this.gruposAdminId = (new Date()).getTime()
                    this.loadingGrupoAdmin = false
                }
                catch{

                }
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        async getDocentesGrupoAcademico() {
            if(this.institucion){
                try {
                    this.loadingDocente = true
                    const { data: response } = await reportes.getDocentesGrupoAcademico(this.institucion)
                    this.docentes = this.getEliminarNameKey(response)
                    this.docentesId = (new Date()).getTime()
                    this.loadingDocente = false
                }
                catch{

                }
            }
        },
        checkByType (type, val) {
            switch (type) {
                case 'string':
                    if (val && val.constructor.name === 'String' && val.trim()) {
                        return true
                    }
                case 'number':
                    if (val && val.constructor.name === 'Number' && val > 0) {
                        return true
                    } 
                case 'array':
                    if (Array.isArray(val) && val.length){
                        return true
                    }
            }
            return false
        },
        sanityForm () {
            this.errorFields = []
            if (!this.checkByType ('number', this.cicloEscolar)) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.checkByType ('number', parseInt(this.institucion))) {
                this.errorFields.push('institucion')
            }
            if (!this.checkByType ('string', this.agrupar)) {
                this.errorFields.push('agrupar')
            }
            if(this.docente == '' && this.grupoAdmin == ''){
                if (!this.checkByType ('number', parseInt(this.grupo))) {
                    this.errorFields.push('grupo')
                }
            }
            if(this.grupo == '' && this.grupoAdmin == ''){
                if (!this.checkByType ('number', parseInt(this.docente))) {
                    this.errorFields.push('docente')
                }
            }
            if(this.docente == '' && this.grupo == ''){
                if (!this.checkByType ('number', parseInt(this.grupoAdmin))) {
                    this.errorFields.push('grupoAdmin')
                }
            }
            if (!this.errorFields.length){
                const params = {
                    institucion_id: this.institucion,
                    ciclo_escolar_id: this.cicloEscolar,
                    group_by: this.agrupar
                }
                if(this.grupo != ''){
                    params.bloque_academico_id = this.grupo
                }
                if(this.docente != ''){
                    params.persona_docente_id =  this.docente
                }
                if(this.grupoAdmin != ''){
                    params.grupo_administrativo_id =  this.grupoAdmin
                }
                return params
            } else {
                return null
            }
        },
        async getGruposAcademicos(){
            const params = this.sanityForm()
            if(params){
                const loading = this.$vs.loading()
                try {
                    const { data: response } = await reportes.getGruposAcademicos(params)
                    this.users = response
                    loading.close()
                    if(response.length == 0){
                        this.mensaje = true
                    }else{
                        this.mensaje = false
                        this.componentKey += 1;
                        this.agruparInfo = this.agrupar
                    }
                }
                catch{
                    loading.close()
                }
            }
        },
            
        forceRerender() {
            this.componentKey += 1;
        },
        borrarFiltros(tipo){
            if(tipo == 'institucion'){
                this.cicloEscolar = ''
                this.ciclosEscolares = []
                this.grupo = ''
                this.grupos = []
                this.docente = ''
                this.docentes = []
                this.grupoAdmin = ''
                this.gruposAdmin = []
            }else if(tipo == 'ciclo'){
                this.grupo = ''
                this.grupos = []
                this.docente = ''
                this.docentes = []
                this.grupoAdmin = ''
                this.gruposAdmin = []
            }
        }
    },
    watch: {
        institucion(){
            this.borrarFiltros('institucion')
            this.getCicloEscolar()
            this.getDocentesGrupoAcademico()
        },
        cicloEscolar(){
            this.borrarFiltros('ciclo')
            this.getGrupo()
            this.getGrupoAdministrativo()
        },
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 30px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 95%;
        }
    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
    .cien {
        width: 100px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }
    .cienCincuenta {
        width: 150px;
        background: none;
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .mdChip{
        background: rgba($color: #000000, $alpha: 0.5);
        margin:1.7% 0;
        padding: 2% 6%;
        text-align: center;
        border-radius: 15px;
        font-size: 11px;
    }

</style>